import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import { CardRow } from 'syf-component-library/ui/atoms';
import { t } from '../../../strings/i18n';
import { DetailsTitle } from './PaymentDetailsContentRow';
const CardRowWrapper = styled(CardRow) `
  margin-bottom: ${spacing.large}px;
`;
export const PaymentDetailsHeader = ({ dataCy, text }) => {
    return (_jsx(CardRowWrapper, Object.assign({ hasBorderBottom: true }, { children: _jsx(DetailsTitle, Object.assign({ "data-cy": dataCy }, { children: t(text) })) })));
};
